import { safeParse } from "@/utils/safeParse";
import axios from "axios";
import { isEmpty } from "lodash";
import { compile } from "path-to-regexp";
import errorHandler from "./requestHandler";
import { getTransferHeaders } from "./server/headerTransfer";

// 请求拦截器
function requestSuccessFn(config) {
  config.withCredentials = true;
  const {
    url,
    options: { params },
    noParse,
  } = config;

  let target = url;

  if (!noParse && target.indexOf(":") > -1) {
    if (!params || isEmpty(params)) {
      throw new Error(`request ${target}` + "Not found Params!");
    }
    target = compile(url)(params);
    config.url = target;
  }

  if (typeof window === "undefined") {
    const serverTransferHeader = getTransferHeaders();
    config.headers = { ...serverTransferHeader, ...(config.headers || null) };
  }

  return config;
}

// 请求统一错误处理
function requestFailFn(error) {
  console.error("[request error]");
  throw error;
}

// 响应拦截器
function responseSuccessFn(res) {
  const {
    options: { returnRes },
  } = res.config;
  const { err } = res.data;

  // 花瓣错误处理逻辑
  if (err) {
    return errorHandler.handler({
      response: res,
      config: res.config,
    });
  }

  let pagination;
  if (res.headers && res.headers["x-pagination"]) {
    pagination = safeParse(res.headers["x-pagination"]);
  }

  // 如果需要返回响应对象，则直接返回
  if (returnRes) {
    return res;
  }

  if (!process.browser) {
    return pagination ? { pagination, data: res.data } : res.data;
  }

  return pagination ? { pagination, data: res.data } : res.data;
}

// 响应统一错误处理
function responseFailFn(error) {
  return errorHandler.handler(error);
}

function createRequest({ BaseURL }) {
  const instance = axios.create({
    baseURL: BaseURL,
  });

  // 请求拦截器
  instance.interceptors.request.use(requestSuccessFn, requestFailFn);

  // 响应拦截器
  instance.interceptors.response.use(responseSuccessFn, responseFailFn);

  return instance;
}

export default createRequest;
